exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index__app-wrapper___3ADiC{box-sizing:border-box;min-height:100vh;margin:0;padding:0;user-select:none}", ""]);

// exports
exports.locals = {
	"app-wrapper": "index__app-wrapper___3ADiC"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--6-1!./node_modules/sass-loader/lib/loader.js!./resources/assets/components/App/index.scss
// module id = GMLM
// module chunks = 0